// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * Additional enum types used in API payloads but not in the
 * archive export (these are entity-specific, not org-wide).
 * Offset register type classification.
 */
export enum RegisterType {
  UNDEFINED = 0,
  BIT = 1,
  VALUE = 2,
  ANALOG = 3,
}
